import { useEffect, useState } from "react";
import { Loader2, RefreshCw, Sparkles, Sun } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { aiOn, useSettings } from "@/context/SettingsContext";

export const BriefingCard = () => {
  const { openTicket } = useApp();
  const { team } = useSettings();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const on = aiOn(team, "briefing");
  const load = async (force = false) => {
    setBusy(true);
    setErr("");
    try { setD((await api.get("/ai/briefing", { params: { force }, timeout: 60000 })).data); } catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  };
  useEffect(() => {
    if (on) load();
  }, [on]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!on) return null;
  return (
    <section className="fade-up mb-6 rounded-2xl border border-cyan-400/20 bg-gradient-to-br from-cyan-400/[0.07] to-transparent p-5 sm:p-6" data-testid="briefing-card">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-lg font-semibold"><Sun className="h-4 w-4 text-amber-300" /> Your day</h2>
        <button onClick={() => load(true)} disabled={busy} className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground" data-testid="briefing-refresh"><RefreshCw className="h-3 w-3" /> Refresh</button>
      </div>
      {busy && !d && <p className="mt-3 flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Reading your tasks…</p>}
      {err && <p className="mt-3 text-sm text-red-300">{err}</p>}
      {d && (
        <div className="mt-3 space-y-3">
          <p className="text-sm leading-relaxed" data-testid="briefing-summary">{d.summary}</p>
          {d.first_title && (
            <button onClick={() => d.first_id && openTicket(d.first_id)} className="flex w-full items-start gap-3 rounded-xl bg-cyan-400/10 p-3 text-left transition-colors hover:bg-cyan-400/15" data-testid="briefing-do-first">
              <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-cyan-300" />
              <span><span className="text-xs font-semibold uppercase tracking-wider text-cyan-300">Do this first</span><span className="block font-semibold">{d.first_title}</span><span className="block text-xs text-muted-foreground">{d.first_why}</span></span>
            </button>
          )}
        </div>
      )}
    </section>
  );
};
